import React, { createContext, Dispatch, SetStateAction, useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_WRITERS } from '../queries/user';

export type IWritersContext = [IUser[], Dispatch<SetStateAction<IUser[]>>]

export const WritersContext = createContext<IWritersContext | null[]>([null, null]);

export const WritersProvider: React.FC = ({ children }) => {
  const [writers, setWriters] = useState<IUser[]>([]);

  const queryWriters = useQuery(GET_WRITERS);

  useEffect(() => {
    if (queryWriters.data) {
      const { data: { userWriters } } = queryWriters;
      setWriters(userWriters);
    }
  }, [queryWriters]);

  return (
    <WritersContext.Provider
      value={[writers, setWriters]}
    >
      {children}
    </WritersContext.Provider>
  );
};
